import { BLOCK_WS, BLOCK_WS_SUCCESS, BLOCK_WS_ERROR} from './actionTypes';

export const blockWorkstations = ( ws, token, history) => {
    return {
        type: BLOCK_WS,
        payload: { ws, token, history }
    }
}

export const blockWorkstationsSuccess = (message) => {
    return {
        type: BLOCK_WS_SUCCESS,
        payload: {message}
    }
}

export const blockWorkstationsError = (ws) => {
    return {
        type: BLOCK_WS_ERROR,
        payload: ws
    }
}
